
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGenericLineCorner as ObiGenericLineCornerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-generic-line-corner.js';
 
 
 

 
 export const ObiGenericLineCorner = createComponent({
   react: React,
   tagName: 'obi-generic-line-corner',
   elementClass: ObiGenericLineCornerElement,
   events: {
     
   }
  });
 
 